module.exports = {
	config: {
		datePicker: {
			locale: 'de',
			format: 'DD.MM.YYYY'
		}
	},

	hooks: {
		attach: function($element, options){
			var moment = require('moment'); // TODO: why not utils.moment?
			var config = this.config.datePicker;

			// NOTE: it is mandatory to provide the defaultDate config parameter as moment-instance in case of format and or locale usage.
			if(this.model.dataDATE && this.model.dataDATE !== null){
				config.defaultDate = moment(this.model.dataDATE);
			}

			$element.datetimepicker(config);
		}
	}
};